import { render, staticRenderFns } from "./ButtonBlock.vue?vue&type=template&id=f4eec6e4&scoped=true&lang=pug&"
import script from "./ButtonBlock.vue?vue&type=script&lang=js&"
export * from "./ButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBlock.vue?vue&type=style&index=0&id=f4eec6e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4eec6e4",
  null
  
)

export default component.exports